import React, { ChangeEvent, ReactElement } from 'react'

import { AttachmentFilterType } from '@features/attachments/enums/attachmentFiltertype'
import { useIsEInvoicingOnly } from '@features/bills/hooks/useIsEInvoicingOnly'

import { useAttachmentsFilters } from '../../../../hooks/useAttachmentsFilters'
import { ReceiptsSearch } from '../../../ReceiptsSearch'
import { ReceiptsSelectAllAction } from '../../../ReceiptsSelectAllAction'
import * as Styled from './styles'

interface ReceiptsLeftActionsProps {
  hideSelectAll?: boolean
  onSelectAllActionChange: (event: ChangeEvent<HTMLInputElement>) => void
  selectedReceiptsCount: number
}

export const ReceiptsLeftActions = ({
  hideSelectAll = false,
  onSelectAllActionChange,
  selectedReceiptsCount,
}: ReceiptsLeftActionsProps): ReactElement => {
  const [{ type }] = useAttachmentsFilters()

  let isSelectable = type !== AttachmentFilterType.EDocument && type !== AttachmentFilterType.Blocked
  isSelectable = useIsEInvoicingOnly() ? true : isSelectable
  const shouldShowSelectAll = isSelectable && !hideSelectAll

  return (
    <Styled.ReceiptsLeftActionsWrapper>
      {shouldShowSelectAll && (
        <ReceiptsSelectAllAction
          onSelectAllCheckboxChange={onSelectAllActionChange}
          selectedReceiptsCount={selectedReceiptsCount}
        />
      )}
      <ReceiptsSearch />
    </Styled.ReceiptsLeftActionsWrapper>
  )
}
